const parseNumber = number => +number || 0;

export default parseNumber;
